
<app-compass-buy [is_from_ad]="true" (link_output)="setLinkOutput($event)"></app-compass-buy>
